import { Tools } from 'wax-prosemirror-core';

/**
 * CitationStyleTool
 *
 * Adds a "Citation Style" button to the editor toolbar.
 * Clicking it fires the 'openCitationStyleSelector' custom event,
 * which Editor.js listens for to show the CitationStyleSelector modal.
 */
class CitationStyleTool extends Tools {
  title = 'Change Citation Style';
  icon = 'settings'; // uses the fantasticon icon set
  name = 'CitationStyle';
  label = 'Citation Styles';

  get run() {
    return () => {
      window.dispatchEvent(new CustomEvent('openCitationStyleSelector'));
      return true;
    };
  }

  get active() {
    return () => false;
  }

  select = () => true;
}

export default CitationStyleTool;
